module.exports = __webpack_public_path__ + "static/media/cybernetic-labs.3d72dab6.svg";